import { ICustomerRelationship } from "@smartrr/shared/entities/CustomerRelationship";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const sendPaymentUpdateEmail =
  (
    customerRelationship: ICustomerRelationship,
    paymentMethodId: string
  ): CustomerThunkAction<
    | "SENDING_PAYMENT_METHOD_UPDATE_EMAIL"
    | "SENDING_PAYMENT_METHOD_UPDATE_EMAIL_SUCCESS"
    | "SENDING_PAYMENT_METHOD_UPDATE_EMAIL_ERROR"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.postReq(
        "/customerRelationship/:customerRelationshipId/update-shopify-payment-method",
        {
          reqBody: { paymentMethodId },
          params: { customerRelationshipId: customerRelationship.id },
        }
      ),
      () =>
        dispatch({
          type: "SENDING_PAYMENT_METHOD_UPDATE_EMAIL",
          payload: undefined,
        }),
      () =>
        dispatch({
          type: "SENDING_PAYMENT_METHOD_UPDATE_EMAIL_ERROR",
          payload: {
            errorMessage: "error sending payment method update email",
          },
        }),
      () =>
        dispatch({
          type: "SENDING_PAYMENT_METHOD_UPDATE_EMAIL_SUCCESS",
          payload: undefined,
        })
    );
